export default __webpack_public_path__ + "static/media/groceries.a25998b9.svg";